export function roundFeeValue(value, digits) {
  const factor = Math.pow(10, digits)
  return Math.round((parseFloat(value) + Number.EPSILON) * factor) / factor
}

export function getServiceSplitUnitPrice(fee) {
  if (fee.computingFormula !== '5006' && fee.computingFormula !== '9010') return null

  let electricPrice = 0
  if (fee.computingFormula === '5006') {
    electricPrice = parseFloat(fee.squarePrice) || 0
  } else {
    const mwPrice = parseFloat(fee.mwPrice)
    electricPrice = mwPrice > 0 ? mwPrice : parseFloat(fee.squarePrice) || 0
  }

  return {
    electricPrice: electricPrice,
    servicePrice: parseFloat(fee.additionalAmount) || 0
  }
}

export function computeServiceSplit(fee, totalAmount) {
  const unitPrice = getServiceSplitUnitPrice(fee)
  if (!unitPrice) return null

  const curDegrees = parseFloat(fee.curDegrees)
  const preDegrees = parseFloat(fee.preDegrees)
  const total = parseFloat(totalAmount)
  if (isNaN(curDegrees) || isNaN(preDegrees) || isNaN(total) || total < 0) return null

  const usage = roundFeeValue(curDegrees - preDegrees, 4)
  const electricFee = roundFeeValue(usage * unitPrice.electricPrice, 2)
  let serviceFee = roundFeeValue(usage * unitPrice.servicePrice, 2)

  if (Math.abs(electricFee + serviceFee - total) > 0.01 && total - electricFee >= 0) {
    serviceFee = roundFeeValue(total - electricFee, 2)
  }

  return {
    electricFee: electricFee,
    serviceFee: serviceFee
  }
}


/**
 * 判断计量类费用（5006/9010 拆分项）属于水费还是电费，用于拆分行标题
 * 判定顺序：计量单位 → 费用项名称 → 兜底「水/电费」
 * @param {Object} fee 费用明细行
 * @returns {string} 'waterFee' | 'electricFee' | 'meterFee'（i18n key 后缀）
 */
export function getMeterFeeLabelKey(fee) {
  if (!fee) return 'meterFee'
  const units = String(fee.units || '').toLowerCase()
  const name = String(fee.feeName || '')

  // 1. 优先看计量单位：吨/立方/m³ = 水；度/千瓦/kWh = 电
  if (/吨|立方|m³|m3|水/.test(units)) return 'waterFee'
  if (/度|千瓦|kwh|kw|电/.test(units)) return 'electricFee'

  // 2. 再看费用项名称：含"水" = 水费；含"电" = 电费
  if (name.indexOf('水') > -1) return 'waterFee'
  if (name.indexOf('电') > -1) return 'electricFee'

  // 3. 兜底
  return 'meterFee'
}
